export default "__VITE_ASSET__CihLh0HE__"